import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};

const getters = {
    BDDSPLANLIST: state => {
        return state.bddsplanlist;
    },
    EDITSTATIIOBJ: state => {
        return state.editstatiiobj;
    }
};
const mutations = {
    SET_BDDSPLANLIST: (state, payload) => {
        state.bddsplanlist = payload;
    },
    SET_EDITSTATIIOBJ: (state, payload) => {
        state.editstatiiobj = payload;
    },

};
const actions = {
    // eslint-disable-next-line no-unused-vars
    GET_BDDSPLANLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddsplan/list?' + req);
            context.commit('SET_BDDSPLANLIST', data);
            return data;
        } catch (err) {
            return err;
        }
    },
    GET_EDITSTATIIOBJ: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddsplan/editstati?' + req);
            context.commit('SET_EDITSTATIIOBJ', data);
            return data;
        } catch (err) {
            return err;
        }
    },
    SAVE_BDDSPLANLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/bddsplan/add', req, config);
        return data;
    },
    SAVE_STATIIOBJECT: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/bddsplan/addstati', req, config);
        return data;
    },
    UPDATE_STATIIOBJECT: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/bddsplan/updatestati', req, config);
        return data;
    },
    EXCEL_BDDSPLANLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddsplan/excellist?' + req);
            return data;
        } catch (err) {
            return err;
        }
    },
};


export default {
    state: () => ({
        bddsplanlist: null,
        editstatiiobj: null
    }),
    mutations,
    actions,
    getters
};
